/**
 * LoadingScreen — full-page spinner shown while we determine the
 * teacher's auth state on initial app load. Used by every route
 * guard.
 *
 * a11y: role="status" + aria-live="polite" so screen readers
 * announce "Loading..." when the screen mounts. The spinning
 * <div> is purely decorative — aria-hidden keeps SRs from trying
 * to describe it.
 */
export default function LoadingScreen() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="min-h-screen bg-stone-50 flex items-center justify-center"
    >
      <div className="text-center">
        <div
          aria-hidden="true"
          className="w-12 h-12 border-4 border-brand-700 border-t-transparent rounded-full animate-spin mx-auto mb-4"
        />
        <p className="text-stone-600">Loading...</p>
      </div>
    </div>
  );
}
